export default {
  login: {
    Username: "Username",
    Email: "Email",
    Password: "Password",
  }
}
